import { merge, rebind } from 'react-stockcharts/lib/utils';

import baseIndicator from 'react-stockcharts/lib/indicator/baseIndicator';
import atrCalculator from './atrCalculator';

const ALGORITHM_TYPE = 'ATR';

export default function (sourcePath: string, scaleType: string): any {
	const base = baseIndicator().type(ALGORITHM_TYPE);

	const underlyingAlgorithm = atrCalculator(sourcePath, scaleType);

	const mergedAlgorithm = merge()
		.algorithm(underlyingAlgorithm)
		.merge((datum: any, indicator: any) => {
			datum.atr = indicator;
		});

	const indicator = function (data: any, options = { merge: true }) {
		if (options.merge) {
			if (!base.accessor()) throw new Error(`Set an accessor to ${ALGORITHM_TYPE} before calculating`);
			return mergedAlgorithm(data);
		}
		return underlyingAlgorithm(data);
	};

	rebind(indicator, base, 'id', 'accessor', 'stroke', 'fill', 'echo', 'type');
	rebind(indicator, underlyingAlgorithm, 'options');
	rebind(indicator, mergedAlgorithm, 'merge', 'skipUndefined');

	return indicator as any;
}
